import * as React from "react";
import {Component} from "react";
import { connect } from "react-redux";

import Support from "../../screens/Support";

import {getSupportTypes, sendSupportQuery, getSupportTickets, SptpageSelected} from "./action";

class SupportContainer extends Component {
  render() {
    return <Support 
    getSupportTypes={this.props.getSupportTypes}
    supportTypeList={this.props.supportTypeList}
    supportTypeListCount={this.props.supportTypeListCount}
    sendSupportQuery={this.props.sendSupportQuery}
    getSupportTickets={this.props.getSupportTickets}
    supportTickets={this.props.supportTickets}
    supportTicketsCount={this.props.supportTicketsCount}
    SptpageSelected={this.props.SptpageSelected}
    />;
  }
}
function bindAction(dispatch) {
  return {
    getSupportTypes: () => {
      dispatch(getSupportTypes());
    },
    sendSupportQuery:(val)=>{
      dispatch(sendSupportQuery(val));
    },
    getSupportTickets:(val)=>{
      dispatch(getSupportTickets(val));
    },
    SptpageSelected:(val)=>{
      dispatch(SptpageSelected(val));
    },
   };
}

const mapStateToProps = (state) => {
  return {
    supportTypeList: state.SupportReducer.supportTypeList,
    supportTypeListCount:state.SupportReducer.supportTypeListCount,
    supportTickets:state.SupportReducer.supportTickets,
    supportTicketsCount:state.SupportReducer.supportTicketsCount,
  };
};

export default connect(mapStateToProps, bindAction)(SupportContainer);
